import { inject } from '@angular/core';
import { CanActivateChildFn, Router, UrlTree } from '@angular/router';
import { AuthService } from '../services/auth.service';

/** Rota da própria tela de termos — nunca é interceptada pelo guard. */
export const ROTA_TERMOS = '/termos';

/**
 * Decisão pura (testável): dado o estado de pendência e a URL alvo,
 * `true` libera a navegação; `ROTA_TERMOS` indica que deve redirecionar para os termos.
 */
export function avaliarAceiteTermos(termoPendente: boolean, url: string): true | typeof ROTA_TERMOS {
  if (url.startsWith(ROTA_TERMOS)) return true;
  return termoPendente ? ROTA_TERMOS : true;
}

/**
 * HU-00 (RN004, RN005, RN006, CA02, CA03, CA06) — enquanto o usuário não aceitar a versão
 * vigente dos Termos de Uso, toda navegação sob o shell autenticado é redirecionada para `/termos`.
 * Deve rodar **antes** de `servicoRadioterapiaCnesContextoGuard` (D-01 / OQ-04: aceite antes do CNES).
 */
export const aceiteTermosGuard: CanActivateChildFn = (_route, state): true | UrlTree => {
  const auth = inject(AuthService);
  const router = inject(Router);

  const decisao = avaliarAceiteTermos(auth.isTermoAceitePendente(), state.url);
  return decisao === true ? true : router.parseUrl(ROTA_TERMOS);
};
